import React from 'react';
import Box from '@mui/material/Box';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _ from 'lodash';
import SplitPane from '../SplitPane';
import ResponseBox from '../ResponseBox';
import RequestBox from '../RequestBox';
import { httpPost } from 'src/api';

export interface PostProps {
    operationObject: OpenAPI.OperationObject;
}

const Post: React.FC<PostProps> = ({ operationObject }) => {
    const { responses } = operationObject;

    return (
        <Box>
            <SplitPane
                req={
                    <RequestBox
                        operationObject={operationObject}
                        runRequest={
                            (pathKey, pathParams, queryParams, body) => httpPost(pathKey, pathParams, queryParams, body)
                        }
                    />
                }
                res={<ResponseBox responsesObject={responses} />}
            />
        </Box>
    );
};

export default Post;
